export default __webpack_public_path__ + "media/images/icons/icon_grade-b210a115be8deda342ba1cd816bf4796.svg";